<template>
  <div class="container-center-horizontal">
    <div class="price-1024 screen">
      <div class="overlap-group6-1">
        <img class="rectangle-21-1" :src="rectangle21" alt="Rectangle 21" />
        <div class="rectangle-11-1"></div>
        <left-nav/>
        <info v-bind="globalData" />
      </div>
      <div class="flex-row-38">
        <h1 class="title plusjakartasans-bold-mine-shaft-32px">{{ title }}</h1>
        <div class="overlap-group1-3">
          <img
            class="vector-27"
            src="img/vector-9.svg"
            alt="Vector"
          />
          <div class="fee-pdf-4 heebo-bold-white-24px">
            <a :href="globalData.algtReportPriceListPdf" target="_blank" style="visited: {text-align:center; color:#fff;}">
            {{ feePdf }}
          </a>
          </div>
        </div>
      </div>
      
      <!-- Price Table Section -->
      <div class="price-table-section">
        <PriceTable :priceData="priceListData" viewSize="medium" />
      </div>

      <group46 :algtReportPriceListPdf="globalData.algtReportPriceListPdf"/>
      <foot v-bind="globalData" />
    </div>
  </div>
</template>

<script>
import LeftNav from "./components/Navbar";
import Foot from "./components/Foot1024";
import Info from "./components/Info";
import Group46 from "./price/Group46";
import PriceTable from "../components/PriceTable";
import priceListData from "../price-list-2025";

export default {
  name: "Price1024",
  components: {
    LeftNav,
    Foot,
    Info,
    Group46,
    PriceTable,
  },
  data() {
    return {
      priceListData,
    };
  },
  props: [
    "globalData",
    "rectangle21",
    "title",
    "feePdf",
  ],
};
</script>

<style lang="sass" scoped>
@import '../../variables'

.price-1024
  align-items: center
  background-color: $selago-2
  display: flex
  flex-direction: column
  overflow: hidden
  position: relative
  width: 1024px

.overlap-group6-1
  align-self: flex-start
  height: 300px
  position: relative
  width: 1960px

.rectangle-21-1
  height: 300px
  left: 0
  object-fit: cover
  position: absolute
  top: 0
  width: 1024px

.rectangle-11-1
  background-color: $black-3
  height: 300px
  left: 0
  position: absolute
  top: 0
  width: 1024px

.logo-01-8
  height: 43px
  left: 437px
  position: absolute
  top: 157px
  width: 150px

.group-26
  align-items: center
  display: flex
  height: 20px
  left: 692px
  min-width: 296px
  position: absolute
  top: 30px

.vector-stroke-1
  height: 20px
  width: 20px

.phone-1
  letter-spacing: 0
  line-height: normal
  margin-bottom: 2.0px
  margin-left: 10px
  min-height: 16px
  min-width: 94px
  white-space: nowrap

.vector-26
  height: 16px
  margin-left: 20px
  width: 20px

.infoalgtlabscom-7
  cursor: pointer
  letter-spacing: 0
  line-height: normal
  margin-bottom: 2.0px
  margin-left: 10px
  min-height: 16px
  min-width: 118px
  white-space: nowrap

.flex-row-38
  align-items: center
  display: flex
  gap: 138px
  margin-left: 2.0px
  margin-top: 60px
  min-width: 946px

.title
  letter-spacing: 0
  line-height: normal
  margin-bottom: 2.0px
  min-height: 40px
  min-width: 343px

.overlap-group1-3
  align-items: center
  background-color: $brand
  border-radius: 4px
  display: flex
  gap: 12px
  height: 64px
  min-width: 363px
  padding: 12px 30px

.vector-27
  height: 24px
  margin-bottom: 4.0px
  width: 18px

.fee-pdf-4
  align-self: flex-end
  letter-spacing: 0
  line-height: 38.4px
  min-width: 273px
  white-space: nowrap

.price-table-section
  width: 100%
  max-width: 944px
  margin: 40px auto
</style>
